import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import Navbar from './components/navbar/Navbar';
import Home from './components/home/Home';
import About from './components/about/About';
import Services from './components/services/Services';
import ServiceAreas from './components/serviceAreas/ServiceAreas';
import Testimonail from './components/testimonials/Testimonail';
import Contact from './components/contact/Contact';
import Footer from './components/footer/Footer';
import FloatingButtons from './components/floatingButtons/FloatingButtons';
import ServicePage from './components/servicePage/ServicePage';
import LocationPage from './components/locationPage/LocationPage';
import TrustBadges from './components/trustBadges/TrustBadges';
import GuaranteeBanner from './components/guaranteeBanner/GuaranteeBanner';
import BlogPost from './components/blogPost/BlogPost';
import Sitemap from './components/Sitemap';
import '@fortawesome/fontawesome-free/css/all.min.css';

// AOS Imports
import AOS from 'aos';
import 'aos/dist/aos.css';
import FAQ from './components/faq/FAQ';

// SEO Component
import SEO from './components/seo/SEO';

// Data Imports
import { getServiceBySlug, servicePages } from './data/servicesData';
import { getLocationBySlug, locationPages } from './data/locationsData';
import { blogSlugs } from './data/blogData';

// Main HomePage Component
function HomePage() {
  return (
    <>
      <SEO 
        title="Professional Cleaning Services Melbourne | Sunshine, Werribee, Point Cook"
        description="Professional cleaning services in Melbourne's western suburbs including Sunshine, Werribee, Point Cook, Tarneit & more. End of lease, carpet, domestic and commercial cleaning with same day availability."
      />
      <Home />
      <TrustBadges />
      <About />
      <Services />
      <GuaranteeBanner />
      <ServiceAreas />
      <Testimonail />
      <FAQ />
      <Contact />
      <Sitemap />
    </>
  );
}

function App() {
  useEffect(() => {
    // Only initialize AOS in the browser (not during prerendering)
    if (navigator.userAgent !== 'ReactSnap') {
      AOS.init({
        duration: 1000, // default duration
        once: false,      // animations run only once
      });
    }
  }, []);

  // Scroll to top on route change
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }
  }, []);

  return (
    <HelmetProvider>
      <Router>
        <div className="page-wrapper">
          <Navbar /><br /><br /><br />
          <Routes>
            {/* Home Page */}
            <Route path="/" element={<HomePage />} />

          {/* Service Pages */}
          {servicePages.map((slug) => {
            const service = getServiceBySlug(slug);
            return (
              <Route
                key={slug}
                path={`/${slug}`}
                element={<ServicePage service={service} />}
              />
            );
          })}

          {/* Location Pages */}
          {locationPages.map((slug) => {
            const location = getLocationBySlug(slug);
            return (
              <Route
                key={slug}
                path={`/${slug}`}
                element={<LocationPage location={location} />}
              />
            );
          })}

          {/* Blog Pages */}
          {blogSlugs.map((slug) => (
            <Route
              key={slug}
              path={`/blog/${slug}`}
              element={<BlogPost />}
            />
          ))}
        </Routes>
        <Footer />
        <FloatingButtons />
      </div>
    </Router>
    </HelmetProvider>
  );
}

export default App;
